import React from 'react'

import SvgIcon from 'vlm-ui/dist/common/src/components/SvgIcon'
import MenuItem from 'vlm-ui/dist/common/src/components/MenuItem'
import CloseIcon from 'vlm-ui/dist/common/src/svg/CloseIcon'

import capitalize from '../../utils/capitalize'

import defaultGetMenu, { getMenuProps as defaultGetMenuProps } from '../../components/Post/menu'

import DefaultArchiveComponent from '../post/DefaultArchiveComponent'
import DefaultComponent from './DefaultComponent'

import ArchiveForm from './Forms/ArchiveForm'

import FilterForm from './FilterForm'

function getCustomValidationForDate() {
    return function customValidationForDate(p) {

        const {
            showInitializationErrors,
            messages,
            name
        } = p

        return function custom(value, changedEver) {
            const regex = /^\d{4}-\d{2}-\d{2}$/

            if ((changedEver || (!changedEver && showInitializationErrors))) {
                if (value) {
                    if (!regex.test(value)) {
                        return {
                            error: true,
                            errorMessage: messages[name + 'ValidationInvalidDateFormat']
                        }
                    }

                    const d = new Date(value)
                    if (isNaN(d.getTime())) {
                        return {
                            error: true,
                            errorMessage: messages[name + 'ValidationInvalidDate']
                        }
                    }

                    const [yyyy, mm, dd] = value.split('-').map(Number)
                    if (d.getUTCFullYear() !== yyyy || (d.getUTCMonth() + 1) !== mm || d.getUTCDate() !== dd) {
                        return {
                            error: true,
                            errorMessage: messages[name + 'ValidationInvalidDate']
                        }
                    }
                }
            }

            return { error: false, errorMessage: '' }
        }

    }
}

export default function getComponent(p) {

    const { context, appContext, name = 'user' } = p
    const { routes, menus, labels, messages, titles } = appContext

    const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'
    const N = capitalize(name)

    const { res, req } = context
    const route = res.wappResponse.route
    //const { params } = route
    //const { _id } = params
    const requestPath = route.requestPath
    const user = req.wappRequest.user

    const isAdmin = user && user._status_isFeatured
    //const isAuthor = ((user?._id && user._id.toString() === _id))
    //const isAuthorOrAdmin = (isAuthor || isAdmin)

    if (requestPath.startsWith(routes[ns + 'Route']) && !isAdmin) {
        return null
    }

    if (requestPath.startsWith(routes['employeesRoute']) && !isAdmin) {
        return null
    }

    if (requestPath.startsWith(routes['employersRoute']) && !isAdmin) {
        return null
    }

    const {
        archiveComponentProps = {
            disableAvatars: true,
            selectable: false,
            tableProps: {
                showLabelTitle: true
            }
        },
        componentProps = {},
        Component = DefaultComponent,
        ArchiveComponent = DefaultArchiveComponent,
        ...rest
    } = p

    const professions = res.wappResponse.store.getState('res.responses.professions')
    const menuItems = (professions?.items.length ? professions.items.filter((menu) => menu.showOnMenu) : [])
    const mainProfessions = (menuItems.length ? menuItems.filter((menu) => !menu.parentProfessions?.length) : [])

    return (
        requestPath.startsWith(routes[ns + 'Route']) ||
        requestPath.startsWith(routes['employeesRoute']) ||
        requestPath.startsWith(routes['employersRoute'])
    ) ?
        (props) =>
            <ArchiveComponent
                {...rest}
                {...archiveComponentProps}
                {...props}
                ListToolsProps={{
                    filterProps: {
                        Form: FilterForm,
                        formProps: {
                            formData: {
                                row1: {
                                    isContainer: true,
                                    hiddenContainer: true
                                },
                                userType: {
                                    containerKey: 'row1.userType',
                                    label: appContext.labels[ns + 'FilterUserTypeLabel'],
                                    placeholder: appContext.labels[ns + 'FilterUserTypePlaceholder'],
                                    componentName: 'Select',
                                    options: [
                                        {
                                            label: appContext.labels[ns + 'FilterUserTypeOption1'],
                                            value: 'employee'
                                        },
                                        {
                                            label: appContext.labels[ns + 'FilterUserTypeOption2'],
                                            value: 'employer'
                                        }
                                    ]
                                },
                                'professions': {
                                    containerKey: 'row1.professions',
                                    label: appContext.labels[ns + 'FilterProfessionsLabel'],
                                    placeholder: appContext.labels[ns + 'FilterProfessionsPlaceholder'],
                                    multiple: true,
                                    componentName: 'Select',
                                    options: [
                                        ...mainProfessions.map((profession)=>{

                                            const items = [
                                                ...menuItems.filter((submenu) => {
                                                    const parentProfessions = submenu.parentProfessions ? submenu.parentProfessions.map((parentProfession) => parentProfession?._id || parentProfession) : []
                                                    return parentProfessions.indexOf(profession._id) > -1
                                                })
                                            ]

                                            return {
                                                label: profession.title,
                                                ...items?.length ? {
                                                    items: [
                                                        {
                                                            label: appContext.menus[name + capitalize(profession.slug) + 'ProfessionAll'] ||
                                                                (appContext.menus['get' + N + 'ProfessionAll'] ? appContext.menus['get' + N + 'ProfessionAll']({ profession }) : '') ||
                                                                profession.subtitle ||
                                                                profession.title,
                                                            value: profession.slug
                                                        },
                                                        {
                                                            divider: true
                                                        },
                                                        ...items.map((profession)=>{
                                                            return {
                                                                label: profession.title,
                                                                value: profession.slug
                                                            }
                                                        }),
                                                        {
                                                            divider: true
                                                        },
                                                    ],
                                                    Component: React.forwardRef((props, ref)=>{
                                                        return <MenuItem {...props} ref={ref} startIcon={null} />
                                                    })
                                                } : {
                                                    value: profession.slug,
                                                }
                                            }
                                        })
                                    ],
                                    InputProps: {
                                        checkbox: true,
                                        checkboxIconToEnd: false,
                                        getCheckboxIconButtonProps: function radioButtons({active}) {
                                            return {
                                                size: 'small',
                                                circle: true,
                                                icon: active ?
                                                    <SvgIcon>
                                                        <circle cx="12" cy="12" r="11" fill={"currentColor"}/>
                                                    </SvgIcon>
                                                    : <SvgIcon />,
                                            }
                                        }
                                    }
                                },
                                city: {
                                    isContainer: true,
                                    hiddenContainer: true
                                },
                                ["_operators.invoiceCity.regex"]: {
                                    containerKey: 'city.invoiceCity',
                                    label: appContext.labels[ns + 'FilterInvoiceCityLabel'],
                                },
                                ["_operators.employeeCity.regex"]: {
                                    containerKey: 'city.employeeCity',
                                    label: appContext.labels[ns + 'FilterEmployeeCityLabel'],
                                },
                                age: {
                                    isContainer: true,
                                    hiddenContainer: true
                                },
                                ["_operators.employeeAge.gt"]: {
                                    containerKey: 'age.employeeAgeGt',
                                    label: appContext.labels[ns + 'FilterEmployeeAgeGtLabel'],
                                    schemaType: 'number',
                                    validations: {
                                        numberRange: {
                                            min: 1
                                        }
                                    }
                                },
                                ["_operators.employeeAge.lt"]: {
                                    containerKey: 'age.employeeAgeLt',
                                    label: appContext.labels[ns + 'FilterEmployeeAgeLtLabel'],
                                    schemaType: 'number',
                                    validations: {
                                        numberRange: {
                                            min: 1
                                        }
                                    }
                                },
                                ["employeeGender"]: {
                                    containerKey: 'age.employeeGender',
                                    schemaType: 'string',
                                    label: appContext.labels[ns + 'FilterEmployeeGenderLabel'],
                                    placeholder: appContext.labels[ns + 'FilterEmployeeGenderPlaceholder'],
                                    componentName: 'Select',
                                    options: [
                                        {
                                            label: appContext.labels[ns + 'FilterEmployeeGenderOption1'],
                                            value: 'female'
                                        },
                                        {
                                            label: appContext.labels[ns + 'FilterEmployeeGenderOption2'],
                                            value: 'male'
                                        }
                                    ]
                                },
                                lastLoginDate: {
                                    isContainer: true,
                                    hiddenContainer: true
                                },
                                ["_operators._lastLoginDate.gt"]: {
                                    containerKey: 'lastLoginDate._lastLoginDateGt',
                                    label: appContext.labels[ns + 'FilterLastLoginDateFrom'],
                                    helperText: '2001-01-01',
                                    componentName: 'Calendar',
                                    validations: {
                                        custom: getCustomValidationForDate()
                                    }
                                },
                                ["_operators._lastLoginDate.lt"]: {
                                    containerKey: 'lastLoginDate._lastLoginDateLt',
                                    label: appContext.labels[ns + 'FilterLastLoginDateTo'],
                                    helperText: '2001-01-01',
                                    componentName: 'Calendar',
                                    validations: {
                                        custom: getCustomValidationForDate()
                                    }
                                },
                                createdDate: {
                                    isContainer: true,
                                    hiddenContainer: true
                                },
                                ["_operators._createdDate.gt"]: {
                                    containerKey: 'createdDate._createdDateGt',
                                    label: appContext.labels[ns + 'FilterCreatedDateFrom'],
                                    helperText: '2001-01-01',
                                    componentName: 'Calendar',
                                    validations: {
                                        custom: getCustomValidationForDate()
                                    }
                                },
                                ["_operators._createdDate.lt"]: {
                                    containerKey: 'createdDate._createdDateLt',
                                    label: appContext.labels[ns + 'FilterCreatedDateTo'],
                                    helperText: '2001-01-01',
                                    componentName: 'Calendar',
                                    validations: {
                                        custom: getCustomValidationForDate()
                                    }
                                },
                            }
                        },
                    }
                }}
                MenuItemProps={{
                    ContentComponentProps: {
                        ImageProps: {
                            ComponentProps: {
                                style: {
                                    aspectRatio: '1/1',
                                    width: 'auto',
                                    height: '100%'
                                }
                            }
                        }
                    }
                }}
                name={name}
                {...{
                    getMenuProps: (props) => {
                        return {
                            ...defaultGetMenuProps({ ...props, }),
                            onArchive: function() {
                                const { dialog, utils, name, post, requestProps = {}, onSubmit } = props;
                                dialog.actions.open({
                                    dialogTitle: titles['dialogArchive' + N + 'Title'],
                                    dialogContent: messages['archive' + N + 'Question'],
                                    Form: (props) => <ArchiveForm {...props} name={name} post={post} />,
                                    cancelText: labels['cancel' + N + 'Text'],
                                    submitText: labels['archive' + N + 'Text'],
                                    onSubmit: async function(e, formData) {

                                        const response = await utils.sendRequest({
                                            requestName: name + 'Archive',
                                            args: formData,
                                            redirect: null,
                                            timeOut: 1000,
                                            ...requestProps.onArchiveSuccess ? requestProps.onArchiveSuccess : {}
                                        })

                                        if (onSubmit) {
                                            await onSubmit(e, response, name + 'Archive')
                                        }

                                        return response

                                    },
                                    successMessage: messages['archive' + N + 'Success']
                                })
                            }
                        }
                    },
                    getMenu: (props) => {
                        const menu = defaultGetMenu(props)
                        return [
                            ...menu,
                            {
                                label: menus['archive' + N + 'Menu'],
                                onClick: function(e) {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    if (props.onArchive) {
                                        props.onArchive()
                                    }
                                },
                                role: function(p) {
                                    const isAdmin = p.user && p.user._status_isFeatured
                                    const isFeatured = p.post && p.post._status_isFeatured

                                    if (isFeatured) {
                                        return false
                                    }

                                    if (isAdmin) {
                                        return !!(p.post?._id /*&& (p.page === 'content' || p.page === 'edit'|| !p.page)*/ && p.isList)
                                    }

                                    return false
                                },
                                startIcon: <CloseIcon />,
                                order: 220,
                                color: 'error'
                            },
                        ]
                    },
                }}
            /> :
        (requestPath.startsWith(routes[name + 'Route'])) ?
            (props) => {

                const cProps = {
                    ...rest,
                    ...componentProps,
                    ...props
                }

                return (
                    <Component
                        {...{
                            getProps: ({ pageName, post, user }) => {

                                const isAuthor = ((user?._id && user._id === post?._author) || (user?._id && user._id === post?._author?._id))
                                const isAdmin = user && user._status_isFeatured

                                if (pageName === 'content' && !post?.activeJobs && !post?.profile?._author && !(isAuthor || isAdmin)) {
                                    return {
                                        PaperComponentProps: {
                                            color: undefined,
                                            elevation: 0,
                                            style: {
                                                padding: 0
                                            }
                                        }
                                    }
                                }
                                return {}
                            }
                        }}
                        {...cProps}
                        name={name}
                    />
                )

            }
            : null
}
